import { render, staticRenderFns } from "./HomeB.vue?vue&type=template&id=09c490bb&"
import script from "./HomeB.vue?vue&type=script&lang=js&"
export * from "./HomeB.vue?vue&type=script&lang=js&"
import style0 from "./HomeB.vue?vue&type=style&index=0&id=09c490bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports